// Ekran 02 — tam sayfa kabul görünümü (pane#pane-c-<kod>).
// İçerik tamamen salt-okunur: K15 vitrini — onaylı kayıt değişmez.

import { useQuery } from '@tanstack/react-query'
import { tr, trTarihSaat } from '../../lib/trFormat'
import { lotlar, type LotDurumu } from './api'

export const DURUM_ETIKET: Record<LotDurumu, { metin: string; sinif: string }> = {
  taslak: { metin: 'Taslak', sinif: 'badge b-amber' },
  onayli: { metin: 'Onaylı', sinif: 'badge b-navy' },
  reddedildi: { metin: 'Reddedildi', sinif: 'badge b-red' },
  storno: { metin: 'Storno', sinif: 'badge b-gray' },
}

export default function TamSayfaKabul({ id }: { id: string }) {
  const { data } = useQuery({
    queryKey: ['lot', id],
    queryFn: () => lotlar.detay(id),
  })

  if (!data) return <div className="cell-sub" style={{ padding: 14 }}>Yükleniyor…</div>

  const l = data.lot
  const d = DURUM_ETIKET[l.durum]

  return (
    <>
      <div className="crumb">
        Operasyon / Mal Kabul <b>/ {l.belgeNo}</b>
      </div>

      <div className="d-head">
        <h1 className="d-title">{l.belgeNo}</h1>
        <span className="d-kod">{trTarihSaat(l.zaman)}</span>
        <span className={d.sinif}>{d.metin}</span>
        <div className="page-actions">
          <button
            className="btn btn-sec btn-sm"
            type="button"
            disabled
            title="Fiş yazdırma henüz bağlanmadı"
            onClick={() => undefined}
          >
            Kabul fişi
          </button>
        </div>
      </div>

      <div className="d-grid">
        <div className="card">
          <div className="sect-t">Kabul Bilgileri</div>
          <div className="form-g" style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
            <Alan etiket="Cari" deger={l.cariUnvan} />
            <Alan etiket="Substrat" deger={`${l.stokKod} ${l.stokAd}`} />
            <Alan etiket="Plaka · Şoför" mono
              deger={[l.plaka, l.surucu].filter(Boolean).join(' · ') || '—'} />
            <Alan etiket="Brüt (kg)" mono deger={tr(l.brut, 0)} />
            <Alan etiket="Dara (kg)" mono deger={tr(l.dara, 0)} />
            <Alan etiket="Net (t)" mono deger={tr(l.net, 3)} />
            {/*
              Lot alanı referansın 7. sırasında (ref:706). Belge numarası
              yalnız onaylı kayıtta lot numarasıdır — taslakta `TSL-…` bir iç
              kimlik, onu "Lot" diye göstermek operatörü yanıltırdı (tablo
              sütununda da aynı kural uygulanıyor).
            */}
            <Alan etiket="Lot" mono deger={l.durum === 'onayli' ? l.belgeNo : '—'} />
            <Alan etiket="Numune" mono deger={l.numuneNo ?? '—'} />
            <Alan etiket="Birim fiyat (₺/t)" mono deger={tr(l.birimFiyat, 2)} />
          </div>

          {l.redGerekce && (
            <div style={{ padding: '0 12px 12px' }}>
              <div className="pnote" style={{ margin: 0 }}>{l.redGerekce}</div>
            </div>
          )}
        </div>

        <div>
          <div className="inst">
            <div className="inst-t">Lot teorik potansiyeli</div>
            <div className="inst-3">
              <div className="inst-c">
                <div className="inst-v">{tr(data.potansiyel.biyogaz, 0)}</div>
                <div className="inst-l">Nm³ biyogaz</div>
              </div>
              <div className="inst-c">
                <div className="inst-v">{tr(data.potansiyel.metan, 0)}</div>
                <div className="inst-l">Nm³ metan</div>
              </div>
              <div className="inst-c">
                <div className="inst-v">{tr(data.potansiyel.elektrik, 0)}</div>
                <div className="inst-l">kWh elektrik</div>
              </div>
            </div>
            <div className="inst-note">
              Metan kaynağı:{' '}
              {data.potansiyel.metanKaynagi === 'bmp'
                ? 'ölçülen BMP'
                : data.potansiyel.metanKaynagi === 'ch4'
                  ? 'verim × CH₄% (türetilmiş)'
                  : 'hesaplanamadı — veri eksik'}{' '}
              (K31)
              {/*
                Referansın sağ sütununda tek kart var (ref:711-714); HAO ve
                bakiye için ayrı bir `.side-card` açmak yerine kartın kendi
                dipnotuna iliştiriliyor — veri kaybolmuyor, yerleşim bozulmuyor.
              */}
              {data.haoSonrasi != null && (
                <>
                  {' · '}Havuz HAO {tr(data.haoOncesi, 2)} → {tr(data.haoSonrasi, 2)} ₺/t (K6)
                  {data.bakiyeSonrasi != null && <> · bakiye {tr(data.bakiyeSonrasi, 3)} t</>}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

function Alan({ etiket, deger, mono }: { etiket: string; deger: string; mono?: boolean }) {
  return (
    <div className="fld">
      <label>{etiket}</label>
      <input className={mono ? 'in mono' : 'in'} readOnly value={deger} />
    </div>
  )
}
